module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report"
  }, [_c('PageTitle', {
    attrs: {
      "pagetitle": "访客地域",
      "tip": "访客地域报告帮助您了解网站访客的地理分布情况，可以根据不同地区的访问偏好优化网站运营与广告推广"
    }
  }), _c('CompTimeSpan', {
    attrs: {
      "type": 'normal',
      "compared": _vm.compared
    },
    on: {
      "rangeChange": _vm.resetCompared,
      "compRangeChange": _vm.compRangeChange
    }
  }), _c('div', {
    staticClass: "zone"
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-signal",
      "title": "趋势图"
    }
  }, [_c('div', {
    staticClass: "fr"
  }, [_c('button', {
    staticClass: "btn btn-white btn-small",
    class: {
      'btn-primary': _vm.currentChart == 'line'
    },
    on: {
      "click": function($event) {
        _vm.currentChart = 'line'
      }
    }
  }, [_vm._v("趋势图")]), _c('button', {
    staticClass: "btn btn-white btn-small",
    class: {
      'btn-primary': _vm.currentChart == 'map'
    },
    attrs: {
      "disabled": _vm.currentTab == 'city'
    },
    on: {
      "click": function($event) {
        _vm.currentChart = 'map'
      }
    }
  }, [_vm._v("地图")])]), (_vm.currentChart == 'map') ? _c('div', {
    staticClass: "indices-menu pull-right"
  }, [_c('v-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customIndice),
      expression: "customIndice"
    }],
    attrs: {
      "options": _vm.indicesMenu
    },
    domProps: {
      "value": (_vm.customIndice)
    },
    on: {
      "input": [function($event) {
        _vm.customIndice = $event
      }, _vm.getTop10Data]
    }
  })], 1) : _vm._e(), (_vm.currentChart == 'line') ? _c('IndiceCompare', {
    attrs: {
      "compared": _vm.compared,
      "indicesMenu": _vm.indicesMenu,
      "indice": _vm.customIndice,
      "compIndice": _vm.twoIndice,
      "twoIndiceShow": _vm.twoIndiceShow
    },
    on: {
      "indiceChange": _vm.indiceChange
    }
  }) : _vm._e()], 1), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentChart == 'map'),
      expression: "currentChart == 'map'"
    }],
    staticClass: "geo-distrib-charts"
  }, [_c('tr', [_c('td', {
    attrs: {
      "width": "50%"
    }
  }, [_c('PieChart', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "legend": _vm.provinceLegend,
      "series": _vm.provinceTop10Series,
      "option": _vm.provinPieConf
    }
  })], 1), _c('td', {
    attrs: {
      "width": "50%"
    }
  }, [_c('MapChart', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "name": _vm.geodistriIndiceName,
      "series": _vm.provinceSeries
    }
  })], 1)])]), _c('LineChart', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentChart == 'line'),
      expression: "currentChart == 'line'"
    }],
    attrs: {
      "legend": _vm.legend,
      "yAxis": _vm.yAxis,
      "xAxis": _vm.chartXAxis,
      "series": _vm.chartSeries
    }
  })], 1), _c('div', {
    staticClass: "zone"
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-list",
      "title": _vm.tableTabTitle
    }
  }), _c('div', {
    staticClass: "nav-tabs"
  }, [_c('TabContent', {
    attrs: {
      "title": "主维度：",
      "tablist": _vm.tablist,
      "update": _vm.updateTab
    }
  }, [_c('div', {
    staticClass: "right-tab",
    slot: "extentTab"
  }, [(_vm.total > 0) ? _c('DownloadBtn', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "reportApi": _vm.reportApi,
      "params": _vm.query,
      "pagetitle": _vm.tableTabTitle,
      "subtitle": ""
    }
  }) : _vm._e(), _c('CustomIndice', {
    attrs: {
      "defaults": _vm.defaultCustomIndices
    },
    on: {
      "change": _vm.onCustomIndiceChange
    }
  })], 1), _c('div', {
    slot: "common"
  }, [(_vm.currentTab == 'province') ? _c('p', {
    staticClass: "plan-nav"
  }, [_vm._v("选择二级维度："), _c('v-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sdim),
      expression: "sdim"
    }],
    attrs: {
      "name": "secondaryDim",
      "options": _vm.sdimOptions
    },
    domProps: {
      "value": (_vm.sdim)
    },
    on: {
      "input": function($event) {
        _vm.sdim = $event
      }
    },
    nativeOn: {
      "change": function($event) {
        _vm.sdimChange($event)
      }
    }
  })], 1) : _vm._e(), _c('p', {
    staticClass: "tabAction"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-big",
    attrs: {
      "disabled": _vm.fetchLineChartabled
    },
    on: {
      "click": _vm.fetchLineChartData
    }
  }, [_vm._v("绘制选定行")]), _c('Search', {
    attrs: {
      "placeholder": _vm.placeHolder,
      "defaultValue": _vm.keyword
    },
    on: {
      "doSearch": _vm.doSearch
    }
  })], 1)])])], 1), _c('complex-table', {
    attrs: {
      "columns": _vm.columns,
      "list": _vm.tableDataList,
      "sum": _vm.sum,
      "checkbox": _vm.hasCheckBox,
      "checkbox_length": _vm.checkboxLength,
      "sortKey": _vm.order,
      "sortOrder": _vm.isasc
    }
  }), (_vm.total > _vm.ps) ? _c('v-pagination', {
    attrs: {
      "total": _vm.total,
      "pn": _vm.pg,
      "ps": _vm.ps
    },
    on: {
      "updatepage": _vm.getTableData
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-acf67ce4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-acf67ce4!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/web/geodistrib.vue
// module id = 789
// module chunks = 0